var Expression;
((Expression2) => {
  Expression2.bindExpression = (expression, bind) => {
    return (expression ?? "").replace(/\$\{([\s\S.]*?)\}/g, (_, group) => {
      const [name, param] = group.split(":");
      const binder = bind[name];
      if (!binder) return "";
      if (typeof binder === "function") {
        return binder(bind[param]);
      }
      return binder;
    });
  };
  let Path;
  ((Path2) => {
    Path2.pathNameData = (pathName, urlExpression) => {
      const urls = pathName.split("/");
      const urlExpressions = urlExpression.split("/");
      if (urls.length !== urlExpressions.length) {
        return;
      }
      const data = {};
      for (let i = 0; i < urlExpressions.length; i++) {
        const it = urlExpressions[i];
        const urlit = urls[i];
        const execResult = /^\{(.+)\}$/g.exec(it);
        if (!execResult) {
          if (it !== urlit) {
            return;
          }
          continue;
        }
        const [name, regex] = execResult[1].split(":");
        if (regex && !new RegExp(regex).test(urlit)) {
          return;
        }
        data[name] = urlit;
      }
      return data;
    };
  })(Path = Expression2.Path || (Expression2.Path = {}));
})(Expression || (Expression = {}));
export {
  Expression
};
//# sourceMappingURL=Expression.js.map
